import { render, staticRenderFns } from "./MasterSlaveTableTmpl.vue?vue&type=template&id=725a6f04&scoped=true&"
import script from "./MasterSlaveTableTmpl.vue?vue&type=script&lang=js&"
export * from "./MasterSlaveTableTmpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725a6f04",
  null
  
)

export default component.exports